(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cornerstone-math", [], factory);
	else if(typeof exports === 'object')
		exports["cornerstone-math"] = factory();
	else
		root["cornerstoneMath"] = factory();
})(window, function() {
return 